import { render } from "./CompareWhyWeLoveIt.vue?vue&type=template&id=4e9d7a01"
import script from "./CompareWhyWeLoveIt.vue?vue&type=script&lang=js"
export * from "./CompareWhyWeLoveIt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__